export const ADMIN_ACCESS = {
  ORDERS: 'admin_orders',
  ORDERS_DELIVERY_FEE: 'admin_orders_delivery_fee',
  USERS: 'admin_users',
  CATALOG: 'admin_catalog',
  CATALOG_EDIT: 'admin_catalog_edit',
  RESTAURANTS: 'admin_restaurants',
  RESTAURANTS_EDIT: 'admin_restaurants_edit',
  LEDGER: 'admin_ledger',
}

export function normalizeAdminAccessCodes(raw) {
  if (raw == null) {
    return null
  }
  if (!Array.isArray(raw)) {
    return []
  }
  return raw.map((code) => String(code ?? '').trim()).filter(Boolean)
}
